/* eslint-disable react/prefer-stateless-function */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ActionCard, Image, SharingPopup } from "C4";
import { appContentUrl } from "settings";
import { renderToString } from "react-dom/server";

export default class ShowcaseCollectionCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      viewed: [],
    };
  }

  render() {
    const { appId, image, subtitle, title } = this.props;

    let { url, itemID } = this.props;
    itemID = Number(itemID);

    const fancyOptions = {
      infobar: true,
      thumbs: {
        autoStart: true,
        axis: "x",
      },
      baseClass: "customBox",
      buttons: ["thumbs", "close"],
      // share: {
      //   tpl: renderToString(<SharingPopup url="" />),
      // },
    };

    const { viewed } = this.state;
    let newImage = `${appContentUrl}${appId}/salesCompanion/new_${image}`;
    if (appId > 500) {
      newImage = image;
    }

    let copy = subtitle;
    copy = new DOMParser().parseFromString(copy, "text/html");
    copy = copy.body.textContent || "";
    if (copy.length > 20) {
      copy = `${copy.substring(0, 90)}...`;
    }
    return (
      <div className="showcaseCollection__Card">
        <div
          className="showcaseCollection__Grid--item"
          data-src={`https://travproconnect.com/profile/${itemID}`}
          data-type="iframe"
          data-fancybox={itemID}
          dataOptions={JSON.stringify(fancyOptions)}
          data-fancybox-trigger={itemID}
        >
          {viewed.includes(itemID.toString()) && (
            <FontAwesomeIcon
              icon={["far", "check-circle"]}
              className="completed"
            />
          )}
          {/* Dummy image to fool fancybox thumbnails process */}
          {typeof url === "object" && (
            <Image
              src={`${appContentUrl}${appId}/salesCompanion/${url[0]}`}
              alt="placeholder thumbnail"
              className="hidden"
            />
          )}
          <div className="imageContainer">
            {image && <Image src={newImage} alt={image} gradient={false} />}
            {/* <div className="overlay" /> */}
          </div>
          <div
            id={`${title.toLowerCase().replace(" ", "_")}`}
            className="textContainer"
          >
            <ActionCard title={title} superTitle={copy} background />
            <div className="showcase">
              <i>{"Visit Showcase >"}</i>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ShowcaseCollectionCard.propTypes = {
  appId: PropTypes.number.isRequired,
  image: PropTypes.string,
  index: PropTypes.number.isRequired,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  itemID: PropTypes.number.isRequired,
};

ShowcaseCollectionCard.defaultProps = {
  image: "",
  subtitle: "",
  title: "",
  type: "",
};
